module.exports = __webpack_public_path__ + "static/img/bgimg2.dce8b8fa.png";